export default "__VITE_ASSET__Dc8Y6hz8__"